/* Jane Lushka 4.1b: Our fabrics page (contract 4.1b, Builder A). Loaded (defer) by sections/jl-fabrics-index.liquid.
   1. --jl-header-h on <html>: the bottom edge of the sticky header / announcement bar while they stick (same measure as
      assets/jl-collection.js), kept current with a ResizeObserver and on scroll (the header can change height when it
      becomes sticky). The index section sticks at that offset. --jl-fidx-h: the index bar's height, used for
      scroll-margin-top on the fabric sections and the compare table so the heading is never under the bars.
   2. Index chips: chips whose section (#fabric-<handle>) is not on the page are hidden. An IntersectionObserver
      watches the fabric sections through a thin band 40% down the viewport; the chip of the section in that band gets
      .is-current and aria-current="true" (none while the band is above the first section or below the last). The
      chip row scrolls itself (never the page) to keep the current chip centred when it overflows; smooth unless
      reduced motion. No scroll-jacking: clicks are plain anchor jumps.
   Binds once (window flag), safe in the theme editor (re-binds on shopify:section:load). */
(function () {
  'use strict';

  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var root = document.documentElement;

  /* ---------- 1. header height ---------- */
  function headerEls() {
    return [
      document.getElementById('shopify-section-announcement-bar'),
      document.getElementById('shopify-section-header') ||
        document.querySelector('.shopify-section-group-header-group') ||
        document.querySelector('header')
    ];
  }

  function stickyBottom(el) {
    if (!el) return 0;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none') return 0;
    if (cs.position !== 'sticky' && cs.position !== '-webkit-sticky' && cs.position !== 'fixed') return 0;
    var top = parseFloat(cs.top);
    if (isNaN(top)) top = 0;
    var r = el.getBoundingClientRect();
    // a header that slid out of view (transform) counts as gone
    if (r.bottom <= 0) return 0;
    return Math.max(0, Math.min(top + r.height, r.bottom));
  }

  var queued = false;
  var lastH = -1;
  var lastI = -1;
  function measure() {
    queued = false;
    var els = headerEls();
    var h = 0;
    for (var i = 0; i < els.length; i++) h = Math.max(h, stickyBottom(els[i]));
    h = Math.round(h);
    if (h !== lastH) {
      lastH = h;
      root.style.setProperty('--jl-header-h', h + 'px');
    }
    var bar = document.querySelector('[data-jl-fidx-bar]');
    var ih = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    if (ih !== lastI) {
      lastI = ih;
      root.style.setProperty('--jl-fidx-h', ih + 'px');
    }
  }
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(measure);
  }

  var ro = null;
  function watchSizes() {
    if (typeof window.ResizeObserver !== 'function') return;
    if (ro) ro.disconnect();
    ro = new window.ResizeObserver(queue);
    var els = headerEls();
    for (var i = 0; i < els.length; i++) if (els[i]) ro.observe(els[i]);
    var bar = document.querySelector('[data-jl-fidx-bar]');
    if (bar) ro.observe(bar);
  }

  /* ---------- 2. index chips ---------- */
  var io = null;
  var visible = {};
  var current = null;

  function chips() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-jl-fidx]'));
  }

  function centreChip(chip) {
    var list = chip.closest('[data-jl-fidx-list]');
    if (!list || list.scrollWidth <= list.clientWidth + 1) return;
    var li = chip.parentElement || chip;
    var left = li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2;
    left = Math.max(0, Math.min(left, list.scrollWidth - list.clientWidth));
    if (Math.abs(list.scrollLeft - left) < 2) return;
    if (typeof list.scrollTo === 'function') list.scrollTo({ left: left, behavior: RM.matches ? 'auto' : 'smooth' });
    else list.scrollLeft = left;
  }

  function setCurrent(handle) {
    if (handle === current) return;
    current = handle;
    var cs = chips();
    for (var i = 0; i < cs.length; i++) {
      var on = cs[i].getAttribute('data-jl-fidx') === handle;
      cs[i].classList.toggle('is-current', on);
      if (on) {
        cs[i].setAttribute('aria-current', 'true');
        centreChip(cs[i]);
      } else {
        cs[i].removeAttribute('aria-current');
      }
    }
  }

  function pick() {
    // the section in the band; when two touch it, the lower one (the one being scrolled into)
    var best = null;
    var bestTop = -Infinity;
    for (var h in visible) {
      if (!visible[h]) continue;
      var t = visible[h].getBoundingClientRect().top;
      if (t > bestTop) {
        bestTop = t;
        best = h;
      }
    }
    setCurrent(best);
  }

  function initChips() {
    var cs = chips();
    if (!cs.length) return;
    var sections = [];
    for (var i = 0; i < cs.length; i++) {
      var h = cs[i].getAttribute('data-jl-fidx');
      var sec = document.getElementById('fabric-' + h);
      var li = cs[i].parentElement;
      if (!sec) {
        if (li) li.hidden = true;
      } else {
        if (li) li.hidden = false;
        sections.push(sec);
      }
    }
    if (io) io.disconnect();
    visible = {};
    current = null;
    if (typeof window.IntersectionObserver !== 'function' || !sections.length) return;
    io = new window.IntersectionObserver(function (entries) {
      for (var j = 0; j < entries.length; j++) {
        var e = entries[j];
        var hh = e.target.getAttribute('data-jl-fabric');
        visible[hh] = e.isIntersecting ? e.target : null;
      }
      pick();
    }, { rootMargin: '-40% 0px -59% 0px', threshold: 0 });
    for (var k = 0; k < sections.length; k++) io.observe(sections[k]);
  }

  function init() {
    if (!document.querySelector('[data-jl-fidx-bar]')) return;
    watchSizes();
    measure();
    initChips();
  }

  if (window.jlFabricsPageReady) return;
  window.jlFabricsPageReady = true;

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () {
    window.setTimeout(init, 0);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
